import React from "react";
import cogoToast from 'cogo-toast';


var answer = [];
class QuizMakeSentence extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      answerArr: [],
      error: "",
      optionSelected: "",
      quiz_data: {
        quiz_title: ""
      },

      question_list: {
        question_title: "",
        question_media: [
          {
            media_path: ""
          }
        ],
        question_options: [
          {
            option_name: "",
            option_id: ""
          }
        ]
      },
      ans: [],
      count: 0,
      rightAns: "none",
      wrongAns: "none",
      quiz_answers: [],
      date: 0
    };
  }
  componentWillMount() {
    this.setState({
      question_list: this.props.unitDetails,
      quiz_data: this.props.Details.quiz_list[0],
      start: this.state.date
    });

    this.setState({ quiz_data: this.props.Details.quiz_list[0] });

    setTimeout(() => {
      const str = this.state.question_list.question_options[0].option_name;
      let temp = [];
      temp = str.split(" ");
      console.log(temp);

      for (let i = temp.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [temp[i], temp[j]] = [temp[j], temp[i]];
      }
      this.setState({ optionsArr: temp });
    }, 100);
  }

  componentDidUpdate() {
    let answer = "";
    this.state.answerArr.map(letter => {
      answer = answer.concat(letter);
    });

  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  tick() {
    this.setState({ date: this.state.date + 1 });
  }

  findAns = ans => {
    return this.state.question_list.question_options.find(item => {
      return parseInt(item.option_id, 10) === parseInt(ans, 10);
    });
  };

  printOption = () => {
    return this.state.optionsArr.map(option => {
      return (
        <div onClick={this.removeFromOption} className="split-letter shadow-sm">
          {option}
        </div>
      );
    });
  };

  removeFromOption = e => {
    if (e.target.classList.contains("split-letter")) {
      e.target.classList.add("blank-item");
    }

    e.target.style.pointerEvents = "none";

    const value = e.target.innerHTML;
    this.setState({
      answerArr: [...this.state.answerArr, value]
    });

    answer.push(e.target.innerHTML);

    var answerWord = answer.join(" ");

    const allSplitBox = document.querySelectorAll(".split-letter ");

    if (allSplitBox.length === answer.length) {
      if (
        answerWord.toLowerCase() ==
        this.state.question_list.question_options[0].option_name.toLowerCase()
      ) {
        this.setState({ rightAns: "block", wrongAns: "none" });
        for (let i = 0; i < allSplitBox.length; i++) {
          allSplitBox[i].style.pointerEvents = "none";
        }
        answer = [];
        this.props.playCorrectAudio();
      
        cogoToast.success('Correct', { position: 'top-center'});
        setTimeout(() => {
          this.nextque();
        }, 3500);
        let obj = {};
        obj.quiz_unit_id = this.state.quiz_data.quiz_unit_id;
        obj.course_unit_id = this.props.Details.course_unit_id;
        obj.coursemaster_id = this.props.Details.coursemaster_id;
        obj.question_id = this.state.question_list.main_question_id;
        obj.start_time = this.state.start;
        obj.no_of_attempted = 1;
        obj.total_point = 5;
        obj.answer_id = this.state.question_list.question_options[0].option_id;
        obj.obtained_score = this.state.quiz_data.marks_for_correct_answer;
        obj.accuracy =
          (100 * this.state.quiz_data.marks_for_correct_answer) /
          this.state.quiz_data.marks_for_correct_answer;
        obj.obtained_point = 5;
        obj.time_spent_duration =
          parseInt(this.state.date) - parseInt(this.state.start);
        obj.total_score = this.state.quiz_data.marks_for_correct_answer;
        obj.end_time = this.state.date;
        if (localStorage.getItem("quiz")) {
          var cart = [];
          cart = JSON.parse(localStorage["quiz"]);
          cart.push(obj);
          console.log(cart);
          localStorage.setItem("quiz", JSON.stringify(cart));
        } else {
          var arra = [];
          arra.push(obj);
          console.log(arra);
          localStorage.setItem("quiz", JSON.stringify(arra));
        }
      } else {
        cogoToast.error('Wrong', { position: 'top-center'});
        this.setState({ rightAns: "none", wrongAns: "block" });
        answer = [];
        this.props.playIncorrectAudio();
        setTimeout(() => {
          this.nextque();
        }, 3500);
        let obj = {};
        obj.quiz_unit_id = this.state.quiz_data.quiz_unit_id;
        obj.course_unit_id = this.props.Details.course_unit_id;
        obj.coursemaster_id = this.props.Details.coursemaster_id;
        obj.question_id = this.state.question_list.main_question_id;
        obj.start_time = this.state.start;
        obj.no_of_attempted = 1;
        obj.total_point = 5;
        obj.answer_id = this.state.question_list.question_options[0].option_id;
        obj.obtained_score = this.state.quiz_data.marks_for_correct_answer;
        obj.accuracy =
          (100 * this.state.quiz_data.marks_for_correct_answer) /
          this.state.quiz_data.marks_for_correct_answer;
        obj.obtained_point = 0;
        obj.time_spent_duration =
          parseInt(this.state.date) - parseInt(this.state.start);
        obj.total_score = this.state.quiz_data.marks_for_correct_answer;
        obj.end_time = this.state.date;
        if (localStorage.getItem("quiz")) {
          var scores = JSON.parse(localStorage.getItem('quiz'))
          var exist = false
          for (let i = 0; i < scores.length; i++) {
            if(obj.question_id == scores[i].question_id){
              scores[i] = obj
              exist = true
              localStorage.setItem("quiz", JSON.stringify(scores));
            }
          }
          if(!exist){
            var cart = [];
            cart = JSON.parse(localStorage["quiz"]);
            cart.push(obj);
            localStorage.setItem("quiz", JSON.stringify(cart));
          }
        } else {
          var arra = [];
          arra.push(obj);
          console.log(arra);
          localStorage.setItem("quiz", JSON.stringify(arra));
        }
      }
      // document.querySelector('.next-btn').classList.remove('disable')

      setTimeout(() => {
        const allAnswerLetter = document.querySelectorAll(".answer-letter");
        for (let i = 0; i < allAnswerLetter.length; i++) {
          allAnswerLetter[i].style.pointerEvents = "none";
        }
      }, 100);
    }

    console.log(
      answerWord.toLowerCase(),
      this.state.question_list.question_options[0].option_name.toLowerCase()
    );
  };

  printAnswer = () => {
    return this.state.answerArr.map(option => {
      return (
        <div onClick={this.removeFromAnswer} className="answer-letter shadow-sm">
          {option}
        </div>
      );
    });
  };

  removeFromAnswer = e => {
    e.target.remove();
    let value = e.target.innerHTML;

    const optionItems = document.querySelectorAll(".split-letter");

    let arr = this.state.answerArr;
    for (let i = 0; i < optionItems.length; i++) {
      if (value === optionItems[i].innerHTML) {
        optionItems[i].classList.remove("blank-item");
        optionItems[i].style.pointerEvents = "unset";
      }
    }

    var pos = answer.indexOf(value);

    answer.splice(pos, 1);
  };

  nextque = () => {
    this.props.parentMethod();
  };

  render() {
    return (
      <div className="quiz-model four-pic-one-word">
        <div className="rounded">
          <div className="heading-block">
            <h3
              className="text-4 text-black m-0 question-quiz text-center"  id="question_title"
              dangerouslySetInnerHTML={{
                __html: this.state.question_list.question_title
              }}
            ></h3>
          </div>
          <div className="modal-body">
            <div className="inner-game-container mx-auto">
              <div className="row">
                <figure
                  className="m-auto text-center"
                  style={{ opacity: this.state.opacity }}
                >
                  <div className="row mb-4 justify-content-around">
                    {this.state.question_list.question_media !== null &&
                    this.state.question_list.question_media !== undefined &&
                    this.state.question_list.question_media !== [] &&
                    this.state.question_list.question_media.length > 0
                      ? this.state.question_list.question_media.map(media => (
                          <div className="col-md-3 px-1">
                            <img
                              alt=" "
                              className="img-thumbnail img-fluid img-category"
                              src={media.media_url ? media.media_url : ""}
                            />
                          </div>
                        ))
                      : ""}
                  </div>
                </figure>
              </div>
              
              <div className="split-answer-word-box d-block d-flex my-3 mx-auto border p-2">
                {this.state.answerArr !== undefined ||
                this.state.answerArr === null
                  ? this.printAnswer()
                  : null}
              </div>
              <div className="text-center text-danger text-3">
                <span> {this.state.error} </span>
              </div>
              <div className="split-word-box d-block d-flex mx-auto mb-3 border p-2">
                {this.state.optionsArr !== undefined
                  ? this.printOption()
                  : null}
              </div>
            </div>
          </div>
        </div>
        <div className="row d-flex justify-content-center my-3 next-btn disable">
         
        </div>
      </div>
    );
  }
}
export default QuizMakeSentence;
